module.exports = __webpack_public_path__ + "img/logo-header.12625140.png";